// extracted by mini-css-extract-plugin
module.exports = {"footer":"layout-module--footer--suRr3","globalWrapper":"layout-module--globalWrapper--1CSPn","flexPage":"layout-module--flexPage--1o9DS"};